// @ts-nocheck
import React, { useState } from 'react';
import { FormattedMessage as T } from '@/components';
import intl from 'react-intl-universal';
import { Intent, Alert } from '@blueprintjs/core';
import withAlertStoreConnect from '@/containers/Alert/withAlertStoreConnect';
import withAlertActions from '@/containers/Alert/withAlertActions';
import { compose } from '@/utils';

/**
 * Generic item data delete alert.
 * Expects payload: { onConfirm: () => void, message?: string }
 */
function ItemDataDeleteAlertComponent({
  name,
  isOpen,
  payload: { onConfirm, message } = {},
  closeAlert,
}) {
  const [isLoading, setLoading] = useState(false);

  const handleCancel = () => closeAlert(name);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      await onConfirm?.();
    } finally {
      setLoading(false);
      closeAlert(name);
    }
  };

  return (
    <Alert
      cancelButtonText={<T id={'cancel'} />}
      confirmButtonText={intl.get('delete')}
      icon="trash"
      intent={Intent.DANGER}
      isOpen={isOpen}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
      loading={isLoading}
    >
      <h3>Are you sure you want to delete?</h3>
      <p>{message ?? 'Once you delete this, you will not be able to restore it.'}</p>
    </Alert>
  );
}

const ItemDataDeleteAlert = compose(
  withAlertStoreConnect(),
  withAlertActions,
)(ItemDataDeleteAlertComponent);

export default [{ name: 'item-data-delete', component: ItemDataDeleteAlert }];
